import React from 'react';
import { CheckCircle, Sun, Clock, HandSoap } from '@phosphor-icons/react';

const TestRoutine = () => {
  // داده‌های دستی روتین پوستی
  const manualRoutineData = {
    "morning_routine": [
      {
        "step": "cleanser",
        "title": "شوینده صورت",
        "description": "پاک‌سازی آلودگی‌ها و آماده‌سازی پوست برای روز.",
        "products": [
          {
            "name": "La Roche-Posay Toleriane Hydrating Gentle Cleanser",
            "brand": "La Roche-Posay",
            "reason": "پاک‌کننده ملایم، مناسب پوست حساس و خشک، بدون ایجاد خشکی اضافی.",
            "how_to_use": "با آب مرطوب کنید و به آرامی ماساژ دهید، سپس آبکشی کنید.",
            "match_score": 90
          },
          {
            "name": "Cerave Hydrating Facial Cleanser",
            "brand": "Cerave",
            "reason": "حاوی سرامید و هیالورونیک اسید، مرطوب‌کننده و آرام‌بخش پوست خشک.",
            "how_to_use": "به صورت ملایم صورت را شستشو دهید و سپس آبکشی کنید.",
            "match_score": 88
          }
        ]
      },
      {
        "step": "toner",
        "title": "تونر مرطوب‌کننده",
        "description": "بازسازی سطح پوست و آماده‌سازی برای مرطوب‌کننده.",
        "products": [
          {
            "name": "Klairs Supple Preparation Facial Toner",
            "brand": "Klairs",
            "reason": "تنظیم pH، مرطوب‌کننده و نرم‌کننده پوست حساس و خشک.",
            "how_to_use": "روی صورت تمیز و خشک اسپری یا با پنبه بزنید.",
            "match_score": 85
          }
        ]
      }
    ],
    "routine_plan": "هفته اول: استفاده از شوینده ملایم و مرطوب‌کننده پایه، تمرکز بر آبرسانی و حفاظت روزانه.",
    "analysis": "کاربر دارای پوست خشک و حساس است که مستعد قرمزی و التهاب می‌باشد.",
    "night_routine": [
      {
        "step": "cleanser",
        "title": "شوینده صورت",
        "description": "پاک‌سازی آلودگی‌ها و آرایش از پوست در پایان روز.",
        "products": [
          {
            "name": "La Roche-Posay Toleriane Hydrating Gentle Cleanser",
            "brand": "La Roche-Posay",
            "reason": "ملایم و مرطوب‌کننده، مناسب پوست حساس و خشک، بدون خشکی.",
            "how_to_use": "با آب مرطوب، صورت را ماساژ دهید و سپس آبکشی کنید.",
            "match_score": 90
          }
        ]
      }
    ],
    "skin_tips": [
      "برای حفظ رطوبت پوست، مصرف آب کافی و استفاده مرتب از مرطوب‌کننده اهمیت دارد.",
      "خواب کافی و استراحت منظم به ترمیم بهتر پوست کمک می‌کند."
    ]
  };

  return (
    <main className="flex-grow flex flex-col pt-6">
      <div className="flex flex-col space-y-8 p-4">
        {/* Header */}
        <div className="text-center pb-4 border-b border-gray-200">
          <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center mb-4 mx-auto">
            <CheckCircle size={42} weight="fill" className="text-green-500" />
          </div>
          <h1 className="text-2xl font-bold text-black mb-2">روتین اختصاصی مراقبت پوستی شما</h1>
          <p className="text-gray-600 text-sm">بر اساس نیازها و شرایط پوستی شما طراحی شده است</p>
        </div>
        
        {/* Analysis */}
        {manualRoutineData.analysis && (
          <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
            <h2 className="text-xl font-bold text-gray-800 mb-3">تحلیل پوست شما</h2>
            <p className="text-gray-700 leading-relaxed text-sm">{manualRoutineData.analysis}</p>
          </div>
        )}
        
        {/* Phased Routine Plan */}
        {manualRoutineData.routine_plan && (
          <div className="bg-purple-50 rounded-xl p-5 border border-purple-100">
            <h2 className="text-xl font-bold text-gray-800 mb-3">برنامه فازبندی شده</h2>
            {typeof manualRoutineData.routine_plan === 'object' ? (
              Object.entries(manualRoutineData.routine_plan).map(([week, desc]) => (
                <div key={week} className="mb-2">
                  <strong>{week}:</strong> {desc}
                </div>
              ))
            ) : (
              <p className="text-gray-700 leading-relaxed text-sm">{manualRoutineData.routine_plan}</p>
            )}
          </div>
        )}
        
        {/* Morning Routine */}
        {manualRoutineData.morning_routine && manualRoutineData.morning_routine.length > 0 && (
          <div className="bg-yellow-50 rounded-xl p-5 border border-yellow-100">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <Sun size={24} weight="fill" className="text-yellow-500 ml-2" />
              روتین صبحگاهی
            </h2>
            
            <div className="space-y-6">
              {manualRoutineData.morning_routine.map((step, index) => (
                <div key={`morning-${index}`} className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
                  <div className="flex items-start mb-3">
                    <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center flex-shrink-0 ml-3">
                      <span className="font-bold text-yellow-600">{index + 1}</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800">{step.title}</h3>
                      <p className="text-sm text-gray-600">{step.description}</p>
                    </div>
                  </div>
                  
                  {step.products && step.products.length > 0 && (
                    <div className="mt-4">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">محصولات پیشنهادی:</h4>
                      <div className="space-y-3">
                        {step.products.map((product, prodIndex) => (
                          <div key={`morning-${index}-product-${prodIndex}`} className="bg-gray-50 rounded-lg p-3 border border-gray-100">
                            <div className="flex justify-between items-start">
                              <div>
                                <h5 className="font-bold text-gray-800">{product.name}</h5>
                                <p className="text-xs text-gray-500">برند: {product.brand}</p>
                              </div>
                              {product.match_score && (
                                <span className="bg-green-100 text-green-800 text-xs font-semibold px-2 py-1 rounded-full">
                                  تناسب: {product.match_score}%
                                </span>
                              )}
                            </div>
                            {product.reason && (
                              <p className="text-xs text-gray-700 mt-2 border-t border-gray-200 pt-2">
                                <span className="font-semibold">دلیل پیشنهاد:</span> {product.reason}
                              </p>
                            )}
                            {product.how_to_use && (
                              <p className="text-xs text-gray-700 mt-2">
                                <span className="font-semibold">روش استفاده:</span> {product.how_to_use}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        
        {/* Night Routine */}
        {manualRoutineData.night_routine && manualRoutineData.night_routine.length > 0 && (
          <div className="bg-indigo-50 rounded-xl p-5 border border-indigo-100">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <Clock size={24} weight="fill" className="text-indigo-500 ml-2" />
              روتین شبانگاهی
            </h2>
            
            <div className="space-y-6">
              {manualRoutineData.night_routine.map((step, index) => (
                <div key={`night-${index}`} className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
                  <div className="flex items-start mb-3">
                    <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0 ml-3">
                      <span className="font-bold text-indigo-600">{index + 1}</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800">{step.title}</h3>
                      <p className="text-sm text-gray-600">{step.description}</p>
                    </div>
                  </div>
                  
                  {step.products && step.products.length > 0 && (
                    <div className="mt-4">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">محصولات پیشنهادی:</h4>
                      <div className="space-y-3">
                        {step.products.map((product, prodIndex) => (
                          <div key={`night-${index}-product-${prodIndex}`} className="bg-gray-50 rounded-lg p-3 border border-gray-100">
                            <div className="flex justify-between items-start">
                              <div>
                                <h5 className="font-bold text-gray-800">{product.name}</h5>
                                <p className="text-xs text-gray-500">برند: {product.brand}</p>
                              </div>
                              {product.match_score && (
                                <span className="bg-green-100 text-green-800 text-xs font-semibold px-2 py-1 rounded-full">
                                  تناسب: {product.match_score}%
                                </span>
                              )}
                            </div>
                            {product.reason && (
                              <p className="text-xs text-gray-700 mt-2 border-t border-gray-200 pt-2">
                                <span className="font-semibold">دلیل پیشنهاد:</span> {product.reason}
                              </p>
                            )}
                            {product.how_to_use && (
                              <p className="text-xs text-gray-700 mt-2">
                                <span className="font-semibold">روش استفاده:</span> {product.how_to_use}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        
        {/* Skin Tips */}
        {manualRoutineData.skin_tips && manualRoutineData.skin_tips.length > 0 && (
          <div className="bg-green-50 rounded-xl p-5 border border-green-100">
            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <HandSoap size={24} weight="fill" className="text-green-500 ml-2" />
              نکات مراقبتی ویژه شما
            </h2>
            
            <ul className="space-y-3">
              {manualRoutineData.skin_tips.map((tip, index) => (
                <li key={`tip-${index}`} className="flex items-start">
                  <span className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 ml-2 mt-0.5">
                    <span className="font-bold text-green-700 text-xs">{index + 1}</span>
                  </span>
                  <p className="text-sm text-gray-700">{tip}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
        
        {/* Action buttons */}
        <div className="space-y-3 pt-4 border-t border-gray-200">
          <button 
            onClick={() => {
              alert("بازگشت به صفحه اصلی");
            }}
            className="w-full bg-black text-white py-3 rounded-full text-sm font-bold"
          >
            ذخیره و بازگشت به صفحه اصلی
          </button>
          
          <button 
            onClick={() => {
              alert("چاپ روتین");
            }}
            className="w-full flex items-center justify-center px-5 py-2 border border-gray-300 rounded-full text-sm text-gray-600 hover:bg-gray-50"
          >
            پرینت / ذخیره PDF
          </button>
        </div>
      </div>
    </main>
  );
};

export default TestRoutine; 